import type { FaireProductEntity } from "../../entity_types/product";

export const p_cso1v004mm: FaireProductEntity = {
  token: "p_cso1v004mm",
  type: "product",
  name: "Thriving Tanzania 100% Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/acc1ff9f5e81447a268343f31e761286f5d63f4e2439a9eb21d4d69d83dddb5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6d29cfaae9dc697906fcffeeeffefd02ae62d89d3c782e06fdd578bc15b7f11.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/f6cdf14ad2dbc0116ca447737270ef13abb306b0cd296a9b25f3b8b7544a5286.jpeg",
    "https://cdn.faire.com/fastly/36c1e39309d9159a8085d90896d6a74e9d0f25f7df6ef33fd766496c4eeb0695.png",
    "https://cdn.faire.com/fastly/020569a8bd82429f65ff89b6403d7b973f5d7f14b06173cdfabc8596cb88db3b.jpeg",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
  ],
  priceDollars: 16.8,
  description:
    'This first ceremonial cacao from Africa is grown amidst the laughter and close relationships of thriving village life. Amidst extensive rice and banana crops, seven hundred certified organic farmers within the biodiverse Kilombero Valley grow cacao for Kokoa Kamili, who takes utmost care to ferment and dry the cacao to exacting standards that offer the best quality on the continent. From our farmers in Tanzania, "Asante" - this is Swahili for thank you!\n\nThis ceremonial cacao comes from 700 small (0.5-2 acre) organic family farms in the Kilombero Valley, which borders Udzungwa Mountains National Park, a spot known for its biodiversity. Our partners here are Kokoa Kamili (Quality Cacao in Swahili), and their model is inspired by our partners in Belize. In its first three years, Kokoa Kamili farmers have received the highest prices for cacao in Tanzania.\n\n• Makes a great coffee replacement!\n• For dark chocolate lovers.\n• Lab tested for heavy metals safety.\n• High flavanol / flavonoid.',
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:41.826Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
